/* eslint-disable react/jsx-no-target-blank */

import React, { memo } from "react";

import {
  BillingIcon,
  BookIcon,
  CacheMenuIcon,
  GearIcon,
  HomeIcon,
  KeysIcon,
  PlaygroundIcon,
  ProjectIcon,
  RequestsMenuIcon,
  ShieldIcon,
  UsageNavIcon,
  UsersIcon,
} from "../icons";
import { SidebarMenuItem } from "./SidebarMenuItem";

const IS_DEV = process.env.REACT_APP_WEB_ENV === "development";

interface MenuItem {
  to: string;
  title: string;
  iconComponent?: React.ReactNode;
}

const organizationMenuItems: MenuItem[] = [
  {
    to: "/organization/settings",
    title: "Settings",
    iconComponent: <GearIcon />,
  },
  {
    to: "/organization/keys",
    title: "Keys",
    iconComponent: <KeysIcon />,
  },
  {
    to: "/organization/members/all",
    title: "Members",
    iconComponent: <UsersIcon />,
  },
];

const responsibleAIMenuItems: MenuItem[] = [
  {
    to: "/safety-compliance/cache",
    title: "Cache",
    iconComponent: <CacheMenuIcon />,
  },
];

if (IS_DEV) {
  responsibleAIMenuItems.push({
    to: "/safety-compliance/shield",
    title: "Shield",
    iconComponent: <ShieldIcon />,
  });
}

const monitoringMenuItems: MenuItem[] = [
  {
    to: "/monitoring/requests",
    title: "Requests",
    iconComponent: <RequestsMenuIcon />,
  },
];

declare global {
  interface Window {
    isDevEnvironment: any;
    isLocalEnvironment: any;
  }
}

interface SidebarNavProps {
  showUsageLink?: boolean;
  isOwner?: boolean;
  hideItems?: boolean;
}

const SidebarNav: React.FC<SidebarNavProps> = memo(
  ({ showUsageLink, isOwner, hideItems }) => {
    return (
      <div className="py-5 nav-container">
        {hideItems || (
          <SidebarMenuItem
            to="/overview"
            title="Overview"
            iconComponent={<HomeIcon />}
          />
        )}

        <SidebarMenuItem
          to="/projects"
          title="Projects"
          iconComponent={<ProjectIcon />}
        />
        {hideItems || (
          <SidebarMenuItem
            to="/playground"
            title="Playground"
            iconComponent={<PlaygroundIcon />}
          />
        )}
        <SidebarMenuItem
          to="https://cogcache.readme.io/reference/quick-start"
          title="Documentation"
          iconComponent={<BookIcon />}
          external
        />
        <div className="menu-item">
          <div className="menu-content pt-8 pb-2">
            <span className="menu-section text-muted fs-8">
              Safety & Compliance
            </span>
          </div>
        </div>

        {responsibleAIMenuItems.map((item, index) => {
          return (
            <SidebarMenuItem key={`responsibleAIMenuItem${index}`} {...item} />
          );
        })}

        <div className="menu-item">
          <div className="menu-content pt-8 pb-2">
            <span className="menu-section text-muted fs-8">
              Monitoring & Insights
            </span>
          </div>
        </div>

        {monitoringMenuItems.map((item, index) => {
          return (
            <SidebarMenuItem key={`organizationMenuItem${index}`} {...item} />
          );
        })}

        <div className="menu-item">
          <div className="menu-content pt-8 pb-2">
            <span className="menu-section text-muted fs-8">Organization</span>
          </div>
        </div>

        {organizationMenuItems.map((item, index) => {
          return (
            <SidebarMenuItem key={`organizationMenuItem${index}`} {...item} />
          );
        })}

        {isOwner && (
          <SidebarMenuItem
            to="/organization/billing"
            title="Billing"
            iconComponent={<BillingIcon />}
          />
        )}

        {showUsageLink && (
          <SidebarMenuItem
            to="/organization/usage"
            title="Usage"
            iconComponent={<UsageNavIcon />}
          />
        )}
      </div>
    );
  },
);
export { SidebarNav };
